var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pcRight"},[_c('div',{staticClass:"operation"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.currentInfo.componentDescribe))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c(_vm.currentInfo.component,{tag:"component"})],1)]),_vm._v(" "),_c('add-dialog',{on:{"addPageItemList":_vm.addPageItemList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ecc2c8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/designPage/components/pcRight.vue
// module id = null
// module chunks = 